module.exports = __webpack_public_path__ + "img/Graph.ee67f9e7.png";